const PASSKEY_LOOKUP_CONTEXT = 'oneckpass:passkey:lookup-v1';

function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function computeHmac(
  key: Uint8Array,
  data: string
): Promise<string> {
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key.buffer as ArrayBuffer,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  const encoded = new TextEncoder().encode(data);
  const signature = await crypto.subtle.sign('HMAC', cryptoKey, encoded);

  return bytesToHex(new Uint8Array(signature));
}

export async function deriveHmacKey(
  encryptionKey: Uint8Array,
  context: string
): Promise<Uint8Array> {
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    encryptionKey.buffer as ArrayBuffer,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  const encoded = new TextEncoder().encode(context);
  const derived = await crypto.subtle.sign('HMAC', cryptoKey, encoded);

  return new Uint8Array(derived);
}

export async function computePasskeyRpIdHash(
  encryptionKey: Uint8Array,
  rpId: string
): Promise<string> {
  const hmacKey = await deriveHmacKey(encryptionKey, PASSKEY_LOOKUP_CONTEXT);
  return computeHmac(hmacKey, rpId);
}

export async function computePasskeyCredentialIdHash(
  encryptionKey: Uint8Array,
  credentialIdBase64: string
): Promise<string> {
  const hmacKey = await deriveHmacKey(encryptionKey, PASSKEY_LOOKUP_CONTEXT);
  return computeHmac(hmacKey, credentialIdBase64);
}
